import React from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import IntegrationCard from "components/Cards/IntegrationCard";

function IntegrationSection({ tabItems }) {
  const navigate = useNavigate();

  return (
    <Grid container spacing={2} justifyContent="flex-start" alignItems="center">
      {tabItems.map((tabItem) => {
        const { connectedStatus } = tabItem;

        return (
          <IntegrationCard
            key={`${tabItem.tabItemId}-integration-card`}
            onClickCb={() =>
              navigate(`/settings/integrations/${tabItem.integrationName?.replaceAll(" ", "_")}`)
            }
            connected={connectedStatus}
            description={tabItem.description}
            parentName={tabItem.integrationName}
          />
        );
      })}
    </Grid>
  );
}

export default IntegrationSection;
